
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type DifferentialSearchPageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function DifferentialSearchPageRT(): TemplateResult<DifferentialSearchPageRTRootProps> {
    function scopeVehicleRequiredNoDifferentialsPositions1() {
        var vehicleRequired = this.responseMessages.includes('DifferentialWizardVehicleRequired');
        var noDifferentials = this.responseMessages.includes('DifferentialWizardNoDifferentials');
        var positions = this.responseExtra?.differential_wizard_groups || [];
        return _createElement('div', { 'className': 'clear-self cm_SearchPage cm_DifferentialSearchPage' }, [this.DifferentialWizardVehicleWidget(function () {
                function repeatSelects1(selects, selectsIndex) {
                    return [selects(function () {
                            function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                                return _createElement('option', {
                                    'disabled': this.loading,
                                    'value': entry.term,
                                    'key': entry.value
                                }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                            }
                            function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                                return _createElement('option', {
                                    'disabled': this.loading,
                                    'value': entry.term,
                                    'key': entry.value
                                }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                            }
                            function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                                var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                                var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                                var isPopularField = popularEntries.length && unpopularEntries.length;
                                return [
                                    !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                        'value': '',
                                        'key': 'null-option'
                                    }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                                    this.loading ? _createElement('option', {
                                        'key': 'loading-option',
                                        'disabled': true
                                    }, _translate(`select_loading`)) : null,
                                    isPopularField ? [
                                        _createElement('option', {
                                            'className': 'cm_option_title',
                                            'disabled': true,
                                            'key': '13251'
                                        }, _translate(`ymm_bar_popular`)),
                                        _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                                        _createElement('option', {
                                            'className': 'cm_option_title',
                                            'disabled': true,
                                            'key': '13254'
                                        }, _translate(`ymm_bar_unpopular`))
                                    ] : null,
                                    _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                                ];
                            }
                            function scopeShowSelectedValues4() {
                                var showSelectedValues = this.selectedEntries.length;
                                return _createElement('option', {
                                    'key': '_current',
                                    'value': '_current'
                                }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                                    _translate(`select_title`),
                                    ' ',
                                    this.title
                                ] : null);
                            }
                            function repeatEntry5(entry, index) {
                                return _createElement('div', {
                                    'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                    'key': entry.value,
                                    'onClick': () => this.onChange(entry.term)
                                }, this.showCheckboxes ? _createElement('input', {
                                    'type': 'checkbox',
                                    'readOnly': true,
                                    'checked': entry.selected,
                                    'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                    'key': '3509'
                                }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                                    'className': 'cm_dropdown_hitCount',
                                    'key': '3711'
                                }, entry.hitCount) : null);
                            }
                            return _createElement('div', { 'className': 'cm_differential-wizard_vehicle-field' }, _createElement('div', { 'className': 'cm_differential-wizard_vehicle-label' }, this.title), [_createElement('div', {
                                    'className': this.extraClassName,
                                    'key': '1240'
                                }, !this.isSearchable ? _createElement('div', {
                                    'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                                    'key': '175'
                                }, this.index || this.index === 0 ? _createElement('span', {
                                    'className': 'index',
                                    'key': '335'
                                }, this.index + 1) : null, _createElement('select', {
                                    'className': 'cm_select_inner-select cm_select__pretty',
                                    'onChange': this.onChange,
                                    'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                                    'disabled': this.disabled,
                                    'aria-label': this.title
                                }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                                            return _createElement('div', { 'className': 'cm_filterInput' });
                                        }, {
                                            widgetName: 'undefined',
                                            items: undefined
                                        })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                                    'div',
                                    {
                                        'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                        'aria-label': this.title,
                                        'key': '2771'
                                    },
                                    !this.hideNullOption ? _createElement('div', {
                                        'className': 'option',
                                        'key': 'null-option',
                                        'onClick': () => this.onChange('')
                                    }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                                    this.loading ? _createElement('div', {
                                        'className': 'option',
                                        'key': 'null-option',
                                        'disabled': true
                                    }, _translate(`select_loading`)) : null,
                                    !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                                ]) : null)]);
                        }, { count: undefined })];
                }
                return _createElement('div', { 'className': 'cm_DifferentialWizardVehicleWidget' }, _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__differential-wizard' }, this.template === 'active' ? _createElement('div', {
                    'className': 'cm_vehicle-widget_dropdowns cmTemplate_active',
                    'key': '121'
                }, _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
                    'div',
                    { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
                    _map(this.selects, repeatSelects1.bind(this))
                ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
                    'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear',
                    'onClick': this.discardVehicle,
                    'disabled': !this.allowToDiscardVehicle,
                    'role': 'button',
                    'tabIndex': this.allowToDiscardVehicle ? '0' : '-1'
                }, '\n          ', _translate(`differential_wizard_reset`), '\n        '))), this.vehicle.Year && this.vehicle.Make && this.vehicle.Model ? _createElement('div', {
                    'className': 'cm_differential-wizard_selected-vehicle',
                    'key': '6807'
                }, '\n      ', [
                    this.vehicle.Year,
                    this.vehicle.Make,
                    this.vehicle.Model,
                    this.vehicle.Drive
                ].filter(Boolean).join(' '), '\n    ') : null) : null));
            }, {
                widgetName: 'undefined',
                items: undefined
            })], !this.isVehicleSelected || vehicleRequired ? _createElement('div', {
            'className': 'cm_message cm_differential-wizard_message',
            'key': '8228'
        }, '\n    ', _translate(`differential_wizard_vehicle_required`), '\n  ') : null, this.isVehicleSelected && noDifferentials ? _createElement('div', {
            'className': 'cm_message cm_differential-wizard_message',
            'key': '8404'
        }, '\n    ', _translate(`differential_wizard_no_differentials`), '\n  ') : null, this.isVehicleSelected && !vehicleRequired && !noDifferentials ? _createElement('div', {
            'className': 'cm_differential-wizard_results',
            'key': '8587'
        }, [this.SearchResult(function () {
                function scopeDifferentialPosition1(position, positionIndex) {
                    var differentialPosition = position;
                    return [_createElement('header', {
                            'className': 'cm_differential-wizard_position',
                            'key': '1570'
                        }, differentialPosition.position === 'Front' ? _createElement('h2', {
                            'className': 'cm_differential-wizard_position-title cm_differential-wizard_position-title__front',
                            'key': '264'
                        }, '\n    ', _translate(`differential_wizard_front_differential`), '\n  ') : null, differentialPosition.position === 'Rear' ? _createElement('h2', {
                            'className': 'cm_differential-wizard_position-title cm_differential-wizard_position-title__rear',
                            'key': '490'
                        }, '\n    ', _translate(`differential_wizard_rear_differential`), '\n  ') : null, differentialPosition.position === 'Differential' ? _createElement('h2', {
                            'className': 'cm_differential-wizard_position-title cm_differential-wizard_position-title__other',
                            'key': '713'
                        }, '\n    ', _translate(`differential_wizard_differential`), '\n  ') : null, _createElement('hr', { 'className': 'cm_differential-wizard_position-line' }))];
                }
                function onClick2(position, positionIndex, differentialGroup, differentialGroupIndex, event) {
                    window.Convermax.toggleDifferentialWizardGroup(event, differentialGroup.differential_code);
                }
                function repeatItems3(position, positionIndex, differentialGroup, differentialGroupIndex, items, itemsIndex) {
                    return [items(function () {
                            function mergeProps(inline, external) {
                                var res = Object.assign({}, inline, external);
                                if (inline.hasOwnProperty('style')) {
                                    res.style = _.defaults(res.style, inline.style);
                                }
                                if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                    res.className = external.className + ' ' + inline.className;
                                }
                                return res;
                            }
                            return this.differential_code === differentialGroup.differential_code ? _createElement('div', {
                                'className': 'cm_differential-wizard_result' + (this.is_differential_wizard_product ? ' cm_differential-wizard_result__product' : ' cm_differential-wizard_result__pseudo'),
                                'key': '17'
                            }, this.is_differential_wizard_subcategory ? [_createElement('header', {
                                    'className': 'cm_differential-wizard_subcategory',
                                    'key': '2940'
                                }, _createElement('h3', { 'className': 'cm_differential-wizard_subcategory-title' }, '\n    ', this.differential_subcategory, ' (', this.differential_subcategory_product_count, ')\n  '))] : null, this.is_differential_wizard_product ? [_createElement('article', {
                                    'className': 'cm_differential-wizard_product',
                                    'key': '5960'
                                }, _createElement('a', {
                                    'href': this.url,
                                    'className': 'cm_differential-wizard_product-image'
                                }, _createElement('img', {
                                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                                    'alt': this.removeHTML(this.title),
                                    'onError': this.onImageError
                                })), _createElement('div', { 'className': 'cm_differential-wizard_product-body' }, this.sku ? _createElement('p', {
                                    'className': 'cm_differential-wizard_product-sku',
                                    'key': '968'
                                }, this.sku) : null, _createElement('a', mergeProps({
                                    'href': this.url,
                                    'className': 'cm_differential-wizard_product-title'
                                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), this.vendor ? _createElement('p', {
                                    'className': 'cm_differential-wizard_product-brand',
                                    'key': '1247'
                                }, this.vendor) : null, _createElement('div', { 'className': 'cm_differential-wizard_product-footer' }, this.price ? _createElement('span', {
                                    'className': 'cm_differential-wizard_product-price',
                                    'key': '1395'
                                }, this.price_varies ? _createElement('span', { 'key': '1474' }, _translate(`price_from`), ' ') : null, '\n        ', this.formatPrice(this.min_price || this.price), '\n      ') : null, _createElement('a', {
                                    'href': this.url,
                                    'className': 'cm_differential-wizard_product-view'
                                }, ' ', _translate(`differential_wizard_view`), ' '))))] : null) : null;
                        }, { count: undefined })];
                }
                function repeatDifferentialGroup4(position, positionIndex, differentialGroup, differentialGroupIndex) {
                    return [
                        [_createElement('article', {
                                'className': 'cm_differential-wizard_group',
                                'key': '11110'
                            }, _createElement('button', {
                                'type': 'button',
                                'className': 'cm_differential-wizard_group-header' + (differentialGroup.differential_is_initially_expanded ? ' cm_differential-wizard_group-header__open' : ''),
                                'aria-expanded': differentialGroup.differential_is_initially_expanded ? 'true' : 'false',
                                'onClick': onClick2.bind(this, position, positionIndex, differentialGroup, differentialGroupIndex)
                            }, _createElement('span', {
                                'className': 'cm_differential-wizard_group-chevron',
                                'aria-hidden': 'true'
                            }), _createElement('img', {
                                'className': 'cm_differential-wizard_group-image',
                                'src': differentialGroup.differential_image || window.Convermax.config.noImageSrc,
                                'alt': differentialGroup.differential_title
                            }), _createElement('span', { 'className': 'cm_differential-wizard_group-content' }, _createElement('span', { 'className': 'cm_differential-wizard_group-title-wrapper' }, _createElement('span', { 'className': 'cm_differential-wizard_group-title' }, differentialGroup.differential_title), differentialGroup.differential_description ? _createElement('span', {
                                'className': 'cm_differential-wizard_group-description',
                                'key': '2079'
                            }, '\n          ', differentialGroup.differential_description, '\n        ') : null), _createElement('span', { 'className': 'cm_differential-wizard_group-meta' }, differentialGroup.differential_note ? _createElement('span', {
                                'className': 'cm_differential-wizard_group-note',
                                'key': '2334'
                            }, '\n          ', differentialGroup.differential_note, '\n        ') : null, _createElement('span', { 'className': 'cm_differential-wizard_group-count' }, '\n          ', differentialGroup.differential_product_count, ' ', _translate(`differential_wizard_parts`), '\n        ')))))],
                        _createElement('div', {
                            'className': 'cm_differential-wizard_group-body' + (!differentialGroup.differential_is_initially_expanded ? ' cm_hide' : ''),
                            'data-differential-wizard-group': differentialGroup.differential_code,
                            'key': '10253'
                        }, _createElement.apply(this, [
                            'div',
                            { 'className': 'cm_differential-wizard_items cmRepeater_items' },
                            _map(this.items, repeatItems3.bind(this, position, positionIndex, differentialGroup, differentialGroupIndex))
                        ]))
                    ];
                }
                function repeatPosition5(position, positionIndex) {
                    return [_createElement.apply(this, [
                            'section',
                            {
                                'className': 'cm_differential-wizard_position-block',
                                'key': '361'
                            },
                            scopeDifferentialPosition1.apply(this, [
                                position,
                                positionIndex
                            ]),
                            _map(position.differential_codes, repeatDifferentialGroup4.bind(this, position, positionIndex))
                        ])];
                }
                return _createElement.apply(this, [
                    'div',
                    { 'className': 'cm_SearchResult' },
                    _map(positions, repeatPosition5.bind(this)),
                    [this.message(function () {
                            return _createElement('div', { 'className': 'cm_message' }, this.demoPlanActive ? [_createElement('div', { 'key': '240' }, '\n  Your store is currently running Convermax Search on a demo plan. The only limitation is that some product\n  images are replaced with a picture of a goose. Please upgrade your plan to remove this restriction.\n')] : null, this.trialExpired ? [_createElement('div', { 'key': '3010' }, _createElement('h2', { 'className': 'cm_message-header' }, 'YMM Search trial period has expired.'), '\n  Product information, including pricing and fitments, is outdated. This store runs on a limited trial version\n  of Convermax Year Make Model fitment search. Please contact\n  ', _createElement('a', {
                                    'href': 'mailto:support@convermax.com',
                                    'className': 'cm_message-link'
                                }, 'support@convermax.com'), ' to complete setup\n  or cancel the integration.\n')] : null, this.aggressiveWheels ? [_createElement('div', { 'key': '7510' }, _translate(`message_aggressive_wheels`, {  vehicleString : this. vehicleString  }))] : null, this.incompatibleParts ? [_createElement('div', {
                                    'className': 'cm_message__incompatible',
                                    'key': '8800'
                                }, _createElement('div', {}, _translate(`message_incompatible_text_results`, {  vehicleString : this. vehicleString  })))] : null, this.nonVehicleSpecificResults ? [_createElement('div', {
                                    'className': 'cm_message__nothing-for-vehicle',
                                    'key': '10670'
                                }, '\n  ', _translate(`message_non_vehicle_specific_results`, {  vehicleString : this. vehicleString  }), '\n  ', _createElement('a', {
                                    'tabIndex': '0',
                                    'className': 'cm_message-link',
                                    'href': this.searchByVehicleUrl
                                }, _translate(`message_view_compatible_products`)))] : null, this.template === 'badRequest' ? _createElement('div', {
                                'className': 'cmTemplate_badRequest',
                                'key': '1390'
                            }, _createElement('div', {}, '\n  ', _translate(`message_search_failed`), '\n  ', _createElement('a', {
                                'tabIndex': '0',
                                'className': 'cm_message-link',
                                'onClick': this.startOver
                            }, _translate(`message_reset_search`)), _createElement('br', {}), this.error ? [
                                '\n    (',
                                this.error.status ? [
                                    _createElement('b', { 'key': '16790' }, 'status:'),
                                    ' ',
                                    this.error.status,
                                    ', '
                                ] : null,
                                this.error.userId ? [
                                    _createElement('b', { 'key': '17660' }, 'id:'),
                                    ' ',
                                    this.error.userId,
                                    ', '
                                ] : null,
                                this.error.timestamp ? [
                                    _createElement('b', { 'key': '18490' }, 'timestamp:'),
                                    ' ',
                                    this.error.timestamp,
                                    ', '
                                ] : null,
                                _createElement('b', { 'key': '16424' }, 'instance:'),
                                ' ',
                                this.error.instance,
                                ')'
                            ] : null)) : null, this.template === 'corrected' ? _createElement('div', {
                                'className': 'cmTemplate_corrected',
                                'key': '2012'
                            }, _createElement('div', {}, _translate(`message_query_corrected`, { 
                                originalQuery: this.
                                originalQuery, 
                                query
                            : this.
                                query
                             }))) : null, this.template === 'networkError' ? _createElement('div', {
                                'className': 'cmTemplate_networkError',
                                'key': '2179'
                            }, _createElement('div', {}, '\n  ', _translate(`message_network_error`), '\n  ', _createElement('br', {}), this.error ? [
                                '\n    (',
                                this.error.status ? [
                                    _createElement('b', { 'key': '23610' }, 'status:'),
                                    ' ',
                                    this.error.status,
                                    ', '
                                ] : null,
                                this.error.userId ? [
                                    _createElement('b', { 'key': '24480' }, 'id:'),
                                    ' ',
                                    this.error.userId,
                                    ', '
                                ] : null,
                                this.error.timestamp ? [
                                    _createElement('b', { 'key': '25310' }, 'timestamp:'),
                                    ' ',
                                    this.error.timestamp,
                                    ', '
                                ] : null,
                                _createElement('b', { 'key': '23244' }, 'instance:'),
                                ' ',
                                this.error.instance,
                                ')'
                            ] : null)) : null, this.template === 'nothing' && !this.hasMessage('KeywordsNotFound') ? [_createElement('div', { 'key': '26940' }, '\n  ', _translate(`message_no_results`), '\n  ', this.query || this.isFacetsSelected || this.isSearchedByVehicle ? _createElement('a', {
                                    'tabIndex': '0',
                                    'className': 'cm_message-link',
                                    'onClick': this.startOver,
                                    'key': '2856'
                                }, _translate(`message_reset_search`)) : null)] : null, this.template === 'partial' ? _createElement('div', {
                                'className': 'cmTemplate_partial',
                                'key': '3058'
                            }, _createElement('div', {}, _translate(`message_query_partial`, {  originalQuery : this. originalQuery  }))) : null, this.template === 'timeout' ? _createElement('div', {
                                'className': 'cmTemplate_timeout',
                                'key': '3212'
                            }, _createElement('div', {}, '\n  ', _translate(`message_timeout`), '\n  ', _createElement('a', {
                                'tabIndex': '0',
                                'className': 'cm_message-link',
                                'onClick': this.retry
                            }, _translate(`message_retry_search`)))) : null, this.template === 'unknown' ? _createElement('div', {
                                'className': 'cmTemplate_unknown',
                                'key': '3452'
                            }, _createElement('div', {}, '\n  ', _translate(`message_search_failed`), '\n  ', _createElement('a', {
                                'tabIndex': '0',
                                'className': 'cm_message-link',
                                'onClick': this.retry
                            }, _translate(`message_retry_search`)), _createElement('br', {}), this.error ? [
                                '\n    (',
                                this.error.status ? [
                                    _createElement('b', { 'key': '37310' }, 'status:'),
                                    ' ',
                                    this.error.status,
                                    ', '
                                ] : null,
                                this.error.userId ? [
                                    _createElement('b', { 'key': '38180' }, 'id:'),
                                    ' ',
                                    this.error.userId,
                                    ', '
                                ] : null,
                                this.error.timestamp ? [
                                    _createElement('b', { 'key': '39010' }, 'timestamp:'),
                                    ' ',
                                    this.error.timestamp,
                                    ', '
                                ] : null,
                                _createElement('b', { 'key': '36944' }, 'instance:'),
                                ' ',
                                this.error.instance,
                                ')'
                            ] : null)) : null, this.hasMessage('LicensePlateNotFound') ? [_createElement('div', { 'key': '40650' }, 'Failed to find your license plate number.')] : null, this.hasMessage('KeywordsNotFound') ? [_createElement('div', { 'key': '42020' }, 'No results found for your keywords.')] : null);
                        }, {
                            widgetName: 'undefined',
                            items: undefined
                        })]
                ]);
            }, {
                widgetName: 'results',
                items: undefined
            })]) : null);
    }
    return scopeVehicleRequiredNoDifferentialsPositions1.apply(this, []);
}
        export const componentNames = ["cm:filterInput","cm:DifferentialWizardVehicleWidget","cm:message","cm:SearchResult"]